import { call, put, takeEvery } from 'redux-saga/effects';
import API from '../../API';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';


async function getApi(data) {
    const apiUrl = API.baseURL + `/album`;
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* myWorks(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.data.code == 200 || response.data.code == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        // history.push('/');
        yield put({ type: 'GET_MY_WORKS_SUCCESS', data: response.data.data.album });
    } catch (e) {
        yield put({ type: 'GET_MY_WORKS_FAILED', message: e.message });
    }
}

function* myWorksSaga() {
    yield takeEvery('GET_MY_WORKS_REQUESTED', myWorks);
}

export default myWorksSaga;